import { Box } from '../../Box';
import { ToastImageContainer } from './ToastImageContainer';
import { ToastContent } from './ToastContent';
import { ToastClose } from './ToastClose';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { RehydratedImage } from './RehydratedImage';
import { baseStyles } from '../../common/baseStyles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const resolveToastStyle = theme => ({
  display: 'flex',
  width: '320px',
  minWidth: '320px',
  maxWidth: '320px',
  flexDirection: 'row',
  alignItems: 'flex-start',
  borderRadius: '4px',
  backgroundColor: theme.tokens.SemColorSurfaceDefault,
  borderColor: theme.tokens.SemColorBorderMuted,
  boxShadow: theme.tokens.BaseShadowMd,
  zIndex: 10,
  border: `1px solid ${theme.tokens.SemColorBorderMuted}`,
  position: 'relative',
  ...baseStyles
});
/**
 * Represents a toast notification component.
 * @param {ToastProps} props - The props for the Toast component.
 * @returns {ReactElement} The rendered Toast component.
 */
export const Toast = props => {
  const theme = useInterstateTheme();
  const {
    handleOnClose
  } = props;
  const {
    id,
    title,
    message,
    image,
    onClick,
    dataTestId,
    serializedImage
  } = props;
  const toastStyle = resolveToastStyle(theme);
  const imageToRender = serializedImage ? /*#__PURE__*/_jsx(RehydratedImage, {
    htmlString: serializedImage
  }) : image;
  return /*#__PURE__*/_jsxs(Box, {
    className: 'ids-toast',
    sx: toastStyle,
    id: id,
    "data-testid": dataTestId,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(ToastImageContainer, {
      image: imageToRender
    }), /*#__PURE__*/_jsx(ToastContent, {
      title: title,
      message: message,
      onClick: onClick
    }), /*#__PURE__*/_jsx(ToastClose, {
      onClick: handleOnClose
    })]
  });
};